import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Alert, Spinner, Row, Col, Image, Button, Badge } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { ResourceManager } from '../../core/resource-manager';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import banner from '../../assets/banner_associati.svg';
import CardCorso from '../../components/Card/Corso';
import courseDefault from '../../assets/course.jpg';
import CardEventoV2 from '../../components/Card/EventoV2';

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, FreeMode, Scrollbar, Navigation } from "swiper/modules";

import 'swiper/css';
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import CardCorsoList from '../../components/Card/CorsoList';



export default function Association() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const { k } = useParams();
    const id = parseInt(k)

    const [data, setData] = useState(null);
    const [corsi, setCorsi] = useState(null);
    const [eventi, setEventi] = useState(null);
    const [convegni, setConvegni] = useState(null);
    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [limit, setLimit] = useState(12)

    useEffect(() => {
        init();
        getCoursesV2();
        getEventi()
        getConvegni()
    }, [id]);


    async function init() {
        var response = await DataManager.getItem('association', id)
        if (response.success === 1) {
            if (response.body.length) {
                var t = response.body[0]
                setData(t)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
                setData({})
            }

            console.warn('association', t)

        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
    }


    async function getCoursesV2() {
        let offset = page * limit - limit;
        var body = {
            limit: limit,
            query: null,
            category: null,
            offset: offset,
            idAssociation: parseInt(id)
        }
        var response = await ApiManager.sendAuthenticatedRequest('/custom/get_courses', body);
        if (response.success === 1) {
            setCorsi(response.body)
        } else {
            setCorsi(null)
        }
    }

    async function getEventi() {
        let constraints = [
            {
                "fieldName": "idAssociation",
                "type": "value",
                "value": id
            },
            {
                "fieldName": "public",
                "type": "value",
                "value": 1
            },
            {
                "fieldName": "type",
                "type": "value",
                "value": "evento"
            }
        ];
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('event', 1, 1000, sorting, '', [], constraints)
        if (response.success === 1 && response.body.length > 0) {
            console.log(response)
            setEventi(response.body)
        } else {
            setEventi(null)
        }
    }


    async function getConvegni() {
        let constraints = [
            {
                "fieldName": "idAssociation",
                "type": "value",
                "value": id
            },
            {
                "fieldName": "public",
                "type": "value",
                "value": 1
            },
            {
                "fieldName": "type",
                "type": "value",
                "value": "convegno"
            }
        ];
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('event', 1, 1000, sorting, '', [], constraints)
        if (response.success === 1 && response.body.length > 0) {
            console.log(response)
            setConvegni(response.body)
        } else {
            setConvegni(null)
        }
    }



    if (data) {
        var image = data.logo ? ResourceManager.getFileUrl(data.logo, 'association') : ""
        return (
            <>
                <Helmet>
                    <title>{LanguageProvider.get('header.associati')}</title>
                </Helmet>


                <Container fluid style={{ "backgroundImage": `url('${banner}')` }} className='p-0 course-header-bg'>
                    <div className=''>
                        <Container fluid='md' className='mb-5 text-light py-5'>

                            {errors.length > 0 &&
                                <Alert variant='danger'>
                                    {errors}
                                </Alert>
                            }
                            <Row>
                                <Col>
                                    <Button style={{ border: 0, color: 'white', backgroundColor: 'transparent' }} className='my-5' onClick={() => window.history.go(-1)}>
                                        <FontAwesomeIcon icon='arrow-left' className='me-2'>
                                        </FontAwesomeIcon>{LanguageProvider.get('defaults.back')}</Button>
                                </Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col>
                                    <Image src={image} width={75}></Image>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h1>{data.name}</h1>
                                    <h4>{data.subname}</h4>
                                </Col>
                            </Row>



                        </Container>
                    </div>
                </Container>


                <Container fluid>
                    <Container fluid='md' className='mt-5 mb-5'>
                        <Row className='justify-content-between'>
                            <Col md={7} xs={12} style={{ color: 'var(--primary-color)' }}>
                                <h3>{LanguageProvider.get('dettaglio_associati.chi_siamo')}</h3>
                                <div dangerouslySetInnerHTML={{ __html: data.description }} className='mb-3'></div>
                            </Col>
                            <Col md={4} xs={12} style={{ backgroundColor: 'var(--secondary-color)', borderRadius: '20px', color: 'var(--primary-color)' }} className='p-4'>
                                <h5>{LanguageProvider.get('dettaglio_associati.contatti')}</h5>
                                <p><b>{data.subname}</b></p>
                                <p>{LanguageProvider.get('dettaglio_associati.mail')}: <b>{data.mail}</b></p>
                                <p>{LanguageProvider.get('dettaglio_associati.sito_web')}: <b>{data.website}</b></p>
                                <p>{LanguageProvider.get('dettaglio_associati.telefono')}: <b>{data.phone}</b></p>
                                <p>{LanguageProvider.get('dettaglio_associati.indirizzo')}: <b>{data.address}</b></p>
                                {data.contacts.length > 0 ? <h5>{LanguageProvider.get('dettaglio_associati.referenti')}</h5> : <></>}
                                {data.contacts.length > 0 && data.contacts.map((c, i) => {
                                    return (<><p key={i}>{c.qualification}: <b>{c.name}</b></p></>)
                                })}


                            </Col>
                        </Row>
                    </Container>
                </Container>


                {corsi ?
                    <Container fluid style={{ backgroundColor: '#f7f7f7' }} className='py-4'>
                        <Container fluid='md' className='mt-5 mb-5'>
                            <Row>
                                <Col xs={12} md={12}>
                                    <h3 style={{ color: 'var(--primary-color)' }}>Corsi</h3>
                                    <Swiper
                                        slidesPerView={'auto'}
                                        spaceBetween={30}
                                        freeMode={false}
                                        grabCursor={true}
                                        scrollbar={true}
                                        pagination={false}
                                        navigation={true}
                                        modules={[FreeMode, Pagination, Scrollbar, Navigation]}
                                        className="home-course-swiper"
                                    >
                                        {corsi.map((item, j) => {
                                            var image = item.image ? ResourceManager.getFileUrl(item.image, 'course') : courseDefault
                                            return (
                                                <SwiperSlide key={j} style={{ "width": '340px' }}>
                                                    <CardCorsoList data={item}></CardCorsoList>
                                                </SwiperSlide>
                                            )
                                        })}

                                    </Swiper>
                                </Col>
                            </Row>
                        </Container>
                    </Container> : <></>}




                {eventi ?
                    <Container fluid className='py-4'>
                        <Container fluid='md' className='mt-5 mb-5'>
                            <Row>
                                <Col xs={12} md={12}>
                                    <h3 style={{ color: 'var(--primary-color)' }} className='mb-4'>Seminari</h3>
                                    <Row>
                                        {eventi.map((item, j) => {
                                            return (
                                                <><Col md={4} xs={12}>
                                                    <CardEventoV2 key={j} data={item}></CardEventoV2>
                                                </Col>
                                                </>
                                            )
                                        })}
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </Container> : <></>}



                {convegni ?
                    <Container fluid className='py-4'>
                        <Container fluid='md' className='mt-5 mb-5'>
                            <Row>
                                <Col xs={12} md={12}>
                                    <h3 style={{ color: 'var(--primary-color)' }} className='mb-4'>Convegni</h3>
                                    <Row>
                                        {convegni.map((item, j) => {
                                            return (
                                                <><Col md={4} xs={12}>
                                                    <CardEventoV2 key={j} data={item}></CardEventoV2>
                                                </Col>
                                                </>
                                            )
                                        })}
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </Container> : <></>}




            </>
        )

    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};